/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-title[_ngcontent-%COMP%]{padding:20px 20px 10px;text-align:center}.modal-title[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-top:10px;display:block}.modal-body[_ngcontent-%COMP%]{text-align:center}.fa[_ngcontent-%COMP%]{font-size:40px;color:#f5be20}.modal-footer[_ngcontent-%COMP%]{background-color:#f0f3f5}.error[_ngcontent-%COMP%]{margin:0 20px 20px}"];
export { styles as styles };
